export const payroll_dedution = [
  {
    key:"1",
    Name: "Absent amount",
    Amount: "$12",
  },
  {
    key:"2",
    Name: "Advance",
    Amount: "$7",
  },
  {
    key:"3",
    Name: "Unpaid leave",
    Amount: "$3",
  },
];
